export const IN_PROGRESS = {
  name: 'IN_PROGRESS',
  display: 'In Progress'
};
export const COMPLETED = {
  name: 'COMPLETED',
  display: 'Completed'
};

export const APPROVAL_REQUIRED = {
  name: 'APPROVAL_REQUIRED',
  display: 'Approval Required'
};
